import React, { useState } from 'react';
import SwipeCard from '../../Components/SwipeCard/SwipeCard';
import Header from '../../Components/Header/Header';

const StudyPage = () => {
  return (
    <div>
      <Header />
      <SwipeCard />
    </div>
  );
};

export default StudyPage;
